import IdentifiersData, { type IdentifiersDataProps, type Identifiers } from './identifiers-data'
import IdentifiersList from './identifiers-list'


type Props = {
  className?: string
  additionalExternalIdentifiers?: Identifiers
  isDataNotValid?: boolean
} & Omit<IdentifiersDataProps, 'children'>

const IdentifiersMain = ({
  className,
  additionalExternalIdentifiers,
  isDataNotValid,
  ...props
}: Props) => (
  <IdentifiersData {...props} isDataNotValid={isDataNotValid}>
    <IdentifiersList
      className={className}
      additionalExternalIdentifiers={additionalExternalIdentifiers}
    />
  </IdentifiersData>
)

export default IdentifiersMain
